import { generateColors } from './color'
import axios from 'axios'
import formula from './formula.json'
import variables from '@/assets/scss/var.scss'
import config from "@/common/config";
import indexCss from "../../assets/theme/index.css"
import extraCss from "../../assets/themeData/extra.css"
let originalStyle = ''

export function writeNewStyle(themeColor) {
  let colors = generateColors(themeColor)
  let cssText = originalStyle
  let colorsCssText = ''
  Object.keys(colors).forEach((key) => {
    cssText = cssText.replace(new RegExp('(:|\\s+)' + key, 'g'), '$1' + `${colors[key]}`)
    colorsCssText += `
      .color-${key}{color: ${colors[key]}!important;}
      .bg-${key}{background-color: ${colors[key]}!important;}
      .border-${key}{border-color: ${colors[key]}!important;}
    `
  })
  document.getElementById('themeStyle').innerText = cssText + colorsCssText
  changeThemeColor(themeColor);
}
function changeThemeColor(themeColor){
  console.log(themeColor)
  switch (themeColor) {
    case '#9e8c6b': //街道
      let themeBgColor = themeColor+'4d'
      //--themeMeunLevelColor:#9E8C6B4D;
      // --themeMeunActiveColor:#9E8C6B4D;
      document.getElementsByTagName('body')[0].style.setProperty('--themeColor', themeColor);
      document.getElementsByTagName('body')[0].style.setProperty('--themeBgColor', '#e6dcca');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunColor', '#FFFFFF');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunFont', '#9e8c6b');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunLevelColor', '#FFFFFF');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunActiveColor', '#9E8C6B');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunActiveFont', '#FFFFFF');
      document.getElementsByTagName('body')[0].style.setProperty('--themeCurrentBgColor', '#fcfbe7');
      document.getElementsByTagName('body')[0].style.setProperty('--themeBarColor', '#ECE8E1');
      document.getElementsByTagName('body')[0].style.setProperty('--themeTableHeaderColor', 'rgba(158,140,107,0.20)');
      break;
    case '#069dbc': //物业
      document.getElementsByTagName('body')[0].style.setProperty('--themeColor', '#0B3258');
      document.getElementsByTagName('body')[0].style.setProperty('--themeBgColor', '#e9f4fa');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunColor', '#103047');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunFont', '#0B3258');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunLevelColor', '#0d2639');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunActiveColor', '#3f8de3');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunActiveFont', '#FFFFFF');
      document.getElementsByTagName('body')[0].style.setProperty('--themeCurrentBgColor', '#CFEDF3');
      document.getElementsByTagName('body')[0].style.setProperty('--themeBarColor', '#EDF8FA');
      break;
    case '#fb5768'://社区
      document.getElementsByTagName('body')[0].style.setProperty('--themeColor', themeColor);
      document.getElementsByTagName('body')[0].style.setProperty('--themeBgColor', '#FB576833');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunColor', '#FFFFFF');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunFont', '#404040');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunLevelColor', '#eaeaea');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunActiveColor', '#FB576833');
      document.getElementsByTagName('body')[0].style.setProperty('--themeMeunActiveFont', '#fb5768');
      document.getElementsByTagName('body')[0].style.setProperty('--themeCurrentBgColor', '#FDEDF1DD');
      document.getElementsByTagName('body')[0].style.setProperty('--themeBarColor', '#FB576833');
      document.getElementsByTagName('body')[0].style.setProperty('--themeTableHeaderColor', 'rgba(251,87,104,0.12)');
      break;
  }
}
export function getIndexStyle() {
  return new Promise((resolve) => {
    console.log(originalStyle)
    if (!originalStyle) {
      console.log(indexCss)
      console.log(extraCss)
      const fileData = indexCss
      const extraFileData = extraCss.replace(/[\r\n]/g, '')
      originalStyle = getStyleTemplate(fileData + extraFileData);
      // axios.all(
      //     [axios({
      //       method:'get',
      //       url:'/theme/index.css'
      //     }),
      //       axios({
      //         method:'get',
      //         url:'/themeData/extra.css'
      //       })
      //         ]).then(
      //   axios.spread((file, extraFile) => {
      //     console.log(file)
      //     console.log(extraFile)
      //     const fileData = file.data
      //     const extraFileData = extraFile.data.replace(/[\r\n]/g, '')
      //     originalStyle = getStyleTemplate(fileData + extraFileData)
      //     resolve()
      //   })
      // )
      resolve()
    } else {
      resolve()
    }
  })
}

export function getStyleTemplate(data) {
  let colors = generateColors(variables.themeColor)
  const colorMap = new Map()
  Object.keys(formula).forEach((key) => {
    colorMap.set(colors[key], key)
  })

  for (let [key, value] of colorMap) {
    data = data.replace(new RegExp(key, 'ig'), value)
  }

  return data
}
